/* eslint-disable no-unused-vars */
import { DatePicker, Popover } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { IconFilter, Left, Right } from '../../../icons'
import { CalendarMode } from '../../../types'
import Button from '../common/Button'
import Icon from '../common/Icon'
// TODO: config đường dẫn dạng @utils, @component,... tương ứng với folder nào ( sửa tất cả e nhé)
import { customDateFormat } from '../../../utils'
import styles from '../SAPPCalendar.module.css'
import SelectBox from '../common/SelectBox'
import ScheduleFilter from './FilterModeType'

interface IHeaderCalendarProps {
  title?: string
  showTeacherName?: boolean
  currentDate: Dayjs
  setCurrentDate: Dispatch<SetStateAction<Dayjs>>
  calendarMode: CalendarMode
  setCalendarMode: Dispatch<SetStateAction<CalendarMode>>
  isFiltered?: boolean
  fetchGetSchedule?: (params?: Object) => void
  loading?: boolean
}

const HeaderCalendar = ({
  title,
  showTeacherName,
  currentDate,
  setCurrentDate,
  calendarMode,
  setCalendarMode,
  isFiltered = false,
  fetchGetSchedule,
  loading
}: IHeaderCalendarProps) => {
  const handleChangeDate = (date: Dayjs) => {
    setCurrentDate(date)
  }

  const handleChangeMode = (mode: any) => {
    setCalendarMode(mode)
    setCurrentDate(currentDate.startOf('month'))
  }

  const [open, setOpen] = useState(false);

  return (
    <div className={styles['header-calendar']}>
      <div className={styles['header-calendar__nav']}>
        <Icon
          icon={<Left />}
          onClick={() =>
            handleChangeDate(currentDate.subtract(1, calendarMode))
          }
        />
        <DatePicker
          picker={calendarMode === 'day' ? 'date' : calendarMode}
          onChange={handleChangeDate}
          format={(value) => customDateFormat(value, 'MMMM, YYYY')}
          value={currentDate}
          allowClear={false}
          suffixIcon={null}
          className={styles['header-calendar__date-picker']}
          size='large'
        />
        <Icon
          icon={<Right />}
          onClick={() => handleChangeDate(currentDate.add(1, calendarMode))}
        />
      </div>
      {showTeacherName && (
        <div className={styles['header-calendar__title']}>{title}</div>
      )}
      <div className={styles['header-calendar__controls']}>
        {/* <Button onClick={() => handleChangeDate(dayjs())}>Today</Button> */}
        {/* <div className={styles['header-calendar__divider']} /> */}

        <Popover
          open={open}
          onOpenChange={setOpen}
          className='sapp-popover' trigger="click" style={{ padding: 8, borderRadius: '6px', background: open ? "#FFB800" : "#F9F9F9", cursor: 'pointer' }} content={<ScheduleFilter fetchGetSchedule={fetchGetSchedule} loading={loading} />} title='Sort Filter' arrow={false} placement='bottomRight'>
          <div style={{ padding: 8, borderRadius: '6px', background: open ? "#FFB800" : "#F9F9F9", cursor: 'pointer' }}>
            <IconFilter open={open} />
          </div>
        </Popover>
        <Button onClick={() => handleChangeDate(dayjs())}>Today</Button>
        <div className={styles['header-calendar__divider']} />
        {
          isFiltered ? (
            <SelectBox
              value={calendarMode}
              options={[
                // {
                //   value: 'today',
                //   label: 'Today'
                // },
                {
                  value: 'month',
                  label: 'Month'
                },
                {
                  value: 'week',
                  label: 'Week'
                }
              ]}
              className='select-mode'
              onChange={(mode) => handleChangeMode(mode as CalendarMode)}
            />
          ) : (
            <React.Fragment>

              <Button
                color={calendarMode === 'month' ? 'primary' : 'default'}
                onClick={() => handleChangeMode('month')}
              >
                Month
              </Button>
              <Button
                color={calendarMode === 'week' ? 'primary' : 'default'}
                onClick={() => handleChangeMode('week')}
              >
                Week
              </Button>
            </React.Fragment>
          )
        }
      </div>
    </div>
  )
}

export default HeaderCalendar
